
export class PageActionAreaCtrl {
  constructor($timeout, $element, $interval, TBService) {
    'ngInject';
    Object.assign(this, { $timeout, $interval, $element });
    this.tb = TBService;
    this.active = false;
  }

  $onInit() {
    this.$timeout(_ => this.applyStyles());
  }

  applyStyles() {
    this.$area = this.$element.find('.page-action-area-rect');
    this.$area.css({
      left: `${this.area.left}%`, top: `${this.area.top}%`,
      width: `${this.area.width}%`, height: `${this.area.height}%`
    });
    this.$page = this.$area.parent().parent().parent();
  }

  onTokenDrop(event, ui) {
    const newToken = $(ui.helper).hasClass('draggable-field');
    this.active = false;
    if (newToken) event.originalEvent._tokenLoadCallback = token => this.adjustAssociatedToken(token);
    else event.originalEvent._tokenDragCallback = token => this.adjustAssociatedToken(token);
  }

  onDragOver() {
    this.active = true;
  }

  onDragLeave() {
    this.active = false;
  }

  adjustAssociatedToken(token) {
    const pageWidth = this.$page.width();
    const pageHeight = this.$page.height();
    const left = parseFloat((pageWidth * (this.area.left / 100)).toFixed(4));
    const top = parseFloat((pageHeight * (this.area.top / 100)).toFixed(4));
    const fieldHeightPx = parseFloat((pageHeight * (this.area.height / 100)).toFixed(4));
    const vwR = this.tb.getVwRatio() * (this.pageZoom / 100);
    const heightVw = parseFloat(((Math.floor(fieldHeightPx) / Math.floor(pageWidth)) * 100 / vwR).toFixed(4));
    const auxToken = angular.copy(token);
    auxToken.fieldSchema.dropDimensions.width = `${this.area.width}%`;
    auxToken.fieldSchema.dropDimensions.height = `${heightVw}vw`;

    token.options = token.options || {};
    token.options.snappedToField = true;
    
    const css = this.tb.getInitialCss({ left, top }, auxToken, this.pageZoom);
    this.tb.applyCssLayout(token, css, false);
  }
}

export default {
  bindings: {
    area: "=",
    pageZoom: "="
  },
  controller: PageActionAreaCtrl,
  templateUrl: 'form-builder/page-action-area/page-action-area.component.html',
}
